import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slices/adminSlice';

export default function AdminProtectedRoute() {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  useEffect(() => {
    const token = localStorage.getItem('token');
    const role =  JSON.parse(localStorage.getItem('user'))?.role;
    if (!token || !isAuthenticated || role !== 'admin') {
      dispatch(logout())
      navigate('/admin-login', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
}
